export const EmailDrawerDisabledHero = () => {
  return (
    <>
      <svg
        width='384'
        height='330'
        viewBox='0 0 384 330'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clip-path='url(#clip0_109_144)'>
          <path
            d='M62.7702 10.8046C81.7702 -1.5254 107.77 -3.9054 127.98 6.8046C189.62 39.4746 159.56 131.675 217.98 167.085C243.7 182.675 278.58 172.715 306.85 178.195C322.4 181.195 337.25 191.465 342.36 206.965C353.97 242.175 325.45 272.805 298.04 290.385C223.65 338.085 120.27 309.935 65.8502 245.015C59.2681 237.188 53.3508 228.826 48.1602 220.015C28.7802 187.015 20.8502 148.015 22.4802 110.015C23.9602 74.8946 30.8902 31.4846 62.7702 10.8046Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.9'
            d='M62.7702 10.8046C81.7702 -1.5254 107.77 -3.9054 127.98 6.8046C189.62 39.4746 159.56 131.675 217.98 167.085C243.7 182.675 278.58 172.715 306.85 178.195C322.4 181.195 337.25 191.465 342.36 206.965C353.97 242.175 325.45 272.805 298.04 290.385C223.65 338.085 120.27 309.935 65.8502 245.015C59.2681 237.188 53.3508 228.826 48.1602 220.015C28.7802 187.015 20.8502 148.015 22.4802 110.015C23.9602 74.8946 30.8902 31.4846 62.7702 10.8046Z'
            fill='white'
          />
          <path
            d='M189.89 343.045C296.972 343.045 383.78 337.976 383.78 331.725C383.78 325.473 296.972 320.405 189.89 320.405C82.8075 320.405 -4 325.473 -4 331.725C-4 337.976 82.8075 343.045 189.89 343.045Z'
            fill='#F5F5F5'
          />
          <path
            d='M101.52 42.4946H1.84021C0.531299 42.4946 -0.529785 43.5557 -0.529785 44.8646V219.025C-0.529785 220.334 0.531299 221.395 1.84021 221.395H101.52C102.829 221.395 103.89 220.334 103.89 219.025V44.8646C103.89 43.5557 102.829 42.4946 101.52 42.4946Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.7'
            d='M101.52 42.4946H1.84021C0.531299 42.4946 -0.529785 43.5557 -0.529785 44.8646V219.025C-0.529785 220.334 0.531299 221.395 1.84021 221.395H101.52C102.829 221.395 103.89 220.334 103.89 219.025V44.8646C103.89 43.5557 102.829 42.4946 101.52 42.4946Z'
            fill='white'
          />
          <path d='M26.2301 65.1646H6.56006V67.8346H26.2301V65.1646Z' fill='rgb(33, 111, 237)' />
          <path d='M26.2301 71.1646H6.56006V73.8346H26.2301V71.1646Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 65.1646H76.6001V67.8346H96.2701V65.1646Z' fill='rgb(33, 111, 237)' />
          <path d='M59.6002 52.8147H39.9302V55.4847H59.6002V52.8147Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 48.1545H6.56006V50.8245H96.2701V48.1545Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2601 79.4846H16.5601V82.1546H96.2601V79.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 84.8147H6.56006V87.4847H96.2701V84.8147Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 90.1545H6.56006V92.8245H96.2701V90.1545Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 95.4846H6.56006V98.1546H96.2701V95.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M86.2601 100.815H6.56006V103.485H86.2601V100.815Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2601 110.505H16.5601V113.175H96.2601V110.505Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 115.835H6.56006V118.505H96.2701V115.835Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 121.175H6.56006V123.845H96.2701V121.175Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 126.505H6.56006V129.175H96.2701V126.505Z' fill='rgb(33, 111, 237)' />
          <path d='M86.2601 131.835H6.56006V134.505H86.2601V131.835Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2601 141.525H16.5601V144.195H96.2601V141.525Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 146.855H6.56006V149.525H96.2701V146.855Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 152.195H6.56006V154.865H96.2701V152.195Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 157.525H6.56006V160.195H96.2701V157.525Z' fill='rgb(33, 111, 237)' />
          <path d='M86.2601 162.855H6.56006V165.525H86.2601V162.855Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2601 173.545H16.5601V176.215H96.2601V173.545Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 178.875H6.56006V181.544H96.2701V178.875Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 184.215H6.56006V186.885H96.2701V184.215Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 189.545H6.56006V192.215H96.2701V189.545Z' fill='rgb(33, 111, 237)' />
          <path d='M86.2601 194.875H6.56006V197.544H86.2601V194.875Z' fill='rgb(33, 111, 237)' />
          <path d='M96.2701 210.255H76.6001V212.925H96.2701V210.255Z' fill='rgb(33, 111, 237)' />
          <g opacity='0.2'>
            <path d='M26.2301 65.1646H6.56006V67.8346H26.2301V65.1646Z' fill='white' />
            <path d='M26.2301 71.1646H6.56006V73.8346H26.2301V71.1646Z' fill='white' />
            <path d='M96.2701 65.1646H76.6001V67.8346H96.2701V65.1646Z' fill='white' />
            <path d='M59.6002 52.8145H39.9302V55.4845H59.6002V52.8145Z' fill='white' />
            <path d='M96.2701 48.1545H6.56006V50.8245H96.2701V48.1545Z' fill='white' />
            <path d='M96.2601 79.4846H16.5601V82.1546H96.2601V79.4846Z' fill='white' />
            <path d='M96.2701 84.8145H6.56006V87.4845H96.2701V84.8145Z' fill='white' />
            <path d='M96.2701 90.1545H6.56006V92.8245H96.2701V90.1545Z' fill='white' />
            <path d='M96.2701 95.4846H6.56006V98.1546H96.2701V95.4846Z' fill='white' />
            <path d='M86.2601 100.814H6.56006V103.484H86.2601V100.814Z' fill='white' />
            <path d='M96.2601 110.505H16.5601V113.175H96.2601V110.505Z' fill='white' />
            <path d='M96.2701 115.834H6.56006V118.504H96.2701V115.834Z' fill='white' />
            <path d='M96.2701 121.175H6.56006V123.845H96.2701V121.175Z' fill='white' />
            <path d='M96.2701 126.505H6.56006V129.175H96.2701V126.505Z' fill='white' />
            <path d='M86.2601 131.834H6.56006V134.504H86.2601V131.834Z' fill='white' />
            <path d='M96.2601 141.524H16.5601V144.194H96.2601V141.524Z' fill='white' />
            <path d='M96.2701 146.854H6.56006V149.524H96.2701V146.854Z' fill='white' />
            <path d='M96.2701 152.195H6.56006V154.865H96.2701V152.195Z' fill='white' />
            <path d='M96.2701 157.524H6.56006V160.194H96.2701V157.524Z' fill='white' />
            <path d='M86.2601 162.854H6.56006V165.524H86.2601V162.854Z' fill='white' />
            <path d='M96.2601 173.544H16.5601V176.214H96.2601V173.544Z' fill='white' />
            <path d='M96.2701 178.875H6.56006V181.544H96.2701V178.875Z' fill='white' />
            <path d='M96.2701 184.215H6.56006V186.885H96.2701V184.215Z' fill='white' />
            <path d='M96.2701 189.544H6.56006V192.214H96.2701V189.544Z' fill='white' />
            <path d='M86.2601 194.875H6.56006V197.544H86.2601V194.875Z' fill='white' />
            <path d='M96.2701 210.255H76.6001V212.925H96.2701V210.255Z' fill='white' />
          </g>
          <path
            opacity='0.1'
            d='M106.52 180.785H50.9203C49.6114 180.785 48.5503 181.846 48.5503 183.155V228.545C48.5503 229.854 49.6114 230.915 50.9203 230.915H106.52C107.829 230.915 108.89 229.854 108.89 228.545V183.155C108.89 181.846 107.829 180.785 106.52 180.785Z'
            fill='black'
          />
          <path
            d='M113.96 190.275H58.3602C57.0513 190.275 55.9902 191.336 55.9902 192.645V238.035C55.9902 239.344 57.0513 240.405 58.3602 240.405H113.96C115.269 240.405 116.33 239.344 116.33 238.035V192.645C116.33 191.336 115.269 190.275 113.96 190.275Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.3'
            d='M113.96 190.275H58.3602C57.0513 190.275 55.9902 191.336 55.9902 192.645V238.035C55.9902 239.344 57.0513 240.405 58.3602 240.405H113.96C115.269 240.405 116.33 239.344 116.33 238.035V192.645C116.33 191.336 115.269 190.275 113.96 190.275Z'
            fill='white'
          />
          <path d='M73.8901 219.485H61.8901V225.485H73.8901V219.485Z' fill='rgb(33, 111, 237)' />
          <path d='M108.89 219.485H74.8901V225.485H108.89V219.485Z' fill='rgb(33, 111, 237)' />
          <path d='M73.8901 211.485H61.8901V218.485H73.8901V211.485Z' fill='rgb(33, 111, 237)' />
          <path d='M73.8901 204.485H61.8901V210.485H73.8901V204.485Z' fill='rgb(33, 111, 237)' />
          <path d='M108.89 211.485H74.8901V218.485H108.89V211.485Z' fill='rgb(33, 111, 237)' />
          <path d='M108.89 226.485H74.8901V233.485H108.89V226.485Z' fill='rgb(33, 111, 237)' />
          <path d='M108.89 204.485H74.8901V210.485H108.89V204.485Z' fill='rgb(33, 111, 237)' />
          <path d='M73.8901 226.485H61.8901V233.485H73.8901V226.485Z' fill='rgb(33, 111, 237)' />
          <path d='M73.8901 196.485H61.8901V203.485H73.8901V196.485Z' fill='rgb(33, 111, 237)' />
          <path d='M108.89 196.485H74.8901V203.485H108.89V196.485Z' fill='rgb(33, 111, 237)' />
          <path
            opacity='0.1'
            d='M123.79 94.1045H68.1903C66.8814 94.1045 65.8203 95.1656 65.8203 96.4745V141.865C65.8203 143.173 66.8814 144.234 68.1903 144.234H123.79C125.099 144.234 126.16 143.173 126.16 141.865V96.4745C126.16 95.1656 125.099 94.1045 123.79 94.1045Z'
            fill='black'
          />
          <path
            d='M134.96 91.7346H79.3602C78.0513 91.7346 76.9902 92.7957 76.9902 94.1046V139.495C76.9902 140.804 78.0513 141.865 79.3602 141.865H134.96C136.269 141.865 137.33 140.804 137.33 139.495V94.1046C137.33 92.7957 136.269 91.7346 134.96 91.7346Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.3'
            d='M134.96 91.7346H79.3602C78.0513 91.7346 76.9902 92.7957 76.9902 94.1046V139.495C76.9902 140.804 78.0513 141.865 79.3602 141.865H134.96C136.269 141.865 137.33 140.804 137.33 139.495V94.1046C137.33 92.7957 136.269 91.7346 134.96 91.7346Z'
            fill='white'
          />
          <path d='M130.89 98.4846H115.89V105.485H130.89V98.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M114.89 98.4846H99.8901V105.485H114.89V98.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M114.89 105.485H99.8901V135.485H114.89V105.485Z' fill='rgb(33, 111, 237)' />
          <path d='M130.89 105.485H115.89V135.485H130.89V105.485Z' fill='rgb(33, 111, 237)' />
          <path d='M98.8901 98.4846H83.8901V105.485H98.8901V98.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M98.8901 105.485H83.8901V135.485H98.8901V105.485Z' fill='rgb(33, 111, 237)' />
          <path
            opacity='0.1'
            d='M142.69 146.715H87.0902C85.7813 146.715 84.7202 147.776 84.7202 149.085V194.475C84.7202 195.784 85.7813 196.845 87.0902 196.845H142.69C143.999 196.845 145.06 195.784 145.06 194.475V149.085C145.06 147.776 143.999 146.715 142.69 146.715Z'
            fill='black'
          />
          <path
            d='M162.96 143.505H107.36C106.051 143.505 104.99 144.566 104.99 145.875V191.265C104.99 192.574 106.051 193.635 107.36 193.635H162.96C164.269 193.635 165.33 192.574 165.33 191.265V145.875C165.33 144.566 164.269 143.505 162.96 143.505Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.3'
            d='M162.96 143.505H107.36C106.051 143.505 104.99 144.566 104.99 145.875V191.265C104.99 192.574 106.051 193.635 107.36 193.635H162.96C164.269 193.635 165.33 192.574 165.33 191.265V145.875C165.33 144.566 164.269 143.505 162.96 143.505Z'
            fill='white'
          />
          <path d='M158.89 150.485H135.89V167.485H158.89V150.485Z' fill='rgb(33, 111, 237)' />
          <path d='M134.89 150.485H111.89V167.485H134.89V150.485Z' fill='rgb(33, 111, 237)' />
          <path d='M134.89 168.485H111.89V187.485H134.89V168.485Z' fill='rgb(33, 111, 237)' />
          <path d='M158.89 168.485H135.89V187.485H158.89V168.485Z' fill='rgb(33, 111, 237)' />
          <path
            opacity='0.2'
            d='M164.89 145.875V179.485H144.16C143.578 179.503 142.999 179.399 142.459 179.179C141.92 178.959 141.434 178.627 141.031 178.207C140.628 177.786 140.318 177.285 140.122 176.737C139.925 176.189 139.846 175.605 139.89 175.025V143.485H162.96C164.27 143.485 164.89 144.565 164.89 145.875Z'
            fill='black'
          />
          <path
            opacity='0.1'
            d='M143.95 46.9746H88.3505C87.0416 46.9746 85.9805 48.0357 85.9805 49.3446V94.7346C85.9805 96.0435 87.0416 97.1046 88.3505 97.1046H143.95C145.259 97.1046 146.32 96.0435 146.32 94.7346V49.3446C146.32 48.0357 145.259 46.9746 143.95 46.9746Z'
            fill='black'
          />
          <path
            d='M153.96 37.9646H98.3602C97.0513 37.9646 95.9902 39.0257 95.9902 40.3346V85.7246C95.9902 87.0335 97.0513 88.0946 98.3602 88.0946H153.96C155.269 88.0946 156.33 87.0335 156.33 85.7246V40.3346C156.33 39.0257 155.269 37.9646 153.96 37.9646Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.3'
            d='M153.96 37.9646H98.3602C97.0513 37.9646 95.9902 39.0257 95.9902 40.3346V85.7246C95.9902 87.0335 97.0513 88.0946 98.3602 88.0946H153.96C155.269 88.0946 156.33 87.0335 156.33 85.7246V40.3346C156.33 39.0257 155.269 37.9646 153.96 37.9646Z'
            fill='white'
          />
          <path d='M138.89 44.4846H119.89V49.4846H138.89V44.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M128.89 50.4846H119.89V81.4846H128.89V50.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M149.89 44.4846H139.89V49.4846H149.89V44.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M149.89 50.4846H139.89V81.4846H149.89V50.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M138.89 50.4846H129.89V81.4846H138.89V50.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M118.89 50.4846H102.89V81.4846H118.89V50.4846Z' fill='rgb(33, 111, 237)' />
          <path d='M118.89 44.4846H102.89V49.4846H118.89V44.4846Z' fill='rgb(33, 111, 237)' />
          <path
            d='M319.98 155.175H251.9C249.299 155.175 247.19 157.283 247.19 159.885V227.965C247.19 230.566 249.299 232.675 251.9 232.675H319.98C322.582 232.675 324.69 230.566 324.69 227.965V159.885C324.69 157.283 322.582 155.175 319.98 155.175Z'
            fill='rgb(33, 111, 237)'
          />
          <path opacity='0.25' d='M314.891 165.305H257.311V222.555H314.891V165.305Z' fill='white' />
          <path
            opacity='0.25'
            d='M257.311 222.485L271.971 210.435L276.761 214.295L291.941 201.475L299.401 208.815L314.891 195.815V222.485H257.311Z'
            fill='white'
          />
          <path
            opacity='0.25'
            d='M257.311 222.485L269.721 199.205L284.221 201.465L295.061 187.305L306.221 189.315L314.891 180.655V222.485H257.311Z'
            fill='white'
          />
          <path
            opacity='0.25'
            d='M257.311 222.485L285.941 218.945L295.221 214.305L305.221 215.305L314.891 210.485V222.485H257.311Z'
            fill='white'
          />
          <path
            opacity='0.2'
            d='M316.89 155.485V163.485C316.836 164.793 316.292 166.034 315.366 166.96C314.439 167.886 313.199 168.431 311.89 168.485H255.89V191.965C255.825 193.227 255.263 194.411 254.325 195.259C253.388 196.106 252.152 196.547 250.89 196.485H246.89V159.885C246.89 157.285 249.29 155.485 251.89 155.485H316.89Z'
            fill='black'
          />
          <path
            d='M225.59 89.3647H157.51C154.909 89.3647 152.8 91.4735 152.8 94.0747V162.155C152.8 164.756 154.909 166.865 157.51 166.865H225.59C228.192 166.865 230.3 164.756 230.3 162.155V94.0747C230.3 91.4735 228.192 89.3647 225.59 89.3647Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.8'
            d='M201.401 97.4546H181.391C180.91 97.4546 180.521 97.8441 180.521 98.3246V109.615C180.521 110.095 180.91 110.485 181.391 110.485H201.401C201.881 110.485 202.271 110.095 202.271 109.615V98.3246C202.271 97.8441 201.881 97.4546 201.401 97.4546Z'
            fill='white'
          />
          <path
            opacity='0.6'
            d='M186.13 125.485H170.28C169.8 125.485 169.41 125.874 169.41 126.355V134.565C169.41 135.045 169.8 135.435 170.28 135.435H186.13C186.611 135.435 187 135.045 187 134.565V126.355C187 125.874 186.611 125.485 186.13 125.485Z'
            fill='white'
          />
          <path
            opacity='0.6'
            d='M212.82 125.485H196.97C196.49 125.485 196.1 125.874 196.1 126.355V134.565C196.1 135.045 196.49 135.435 196.97 135.435H212.82C213.301 135.435 213.69 135.045 213.69 134.565V126.355C213.69 125.874 213.301 125.485 212.82 125.485Z'
            fill='white'
          />
          <path
            opacity='0.4'
            d='M196.41 146.535H188.92C188.44 146.535 188.05 146.924 188.05 147.405V154.165C188.05 154.645 188.44 155.035 188.92 155.035H196.41C196.891 155.035 197.28 154.645 197.28 154.165V147.405C197.28 146.924 196.891 146.535 196.41 146.535Z'
            fill='white'
          />
          <path
            opacity='0.4'
            d='M208.13 146.535H200.641C200.16 146.535 199.771 146.924 199.771 147.405V154.165C199.771 154.645 200.16 155.035 200.641 155.035H208.13C208.611 155.035 209 154.645 209 154.165V147.405C209 146.924 208.611 146.535 208.13 146.535Z'
            fill='white'
          />
          <path
            opacity='0.4'
            d='M219.861 146.535H212.371C211.89 146.535 211.5 146.924 211.5 147.405V154.165C211.5 154.645 211.89 155.035 212.371 155.035H219.861C220.341 155.035 220.73 154.645 220.73 154.165V147.405C220.73 146.924 220.341 146.535 219.861 146.535Z'
            fill='white'
          />
          <path
            opacity='0.4'
            d='M169.28 146.535H161.79C161.31 146.535 160.92 146.924 160.92 147.405V154.165C160.92 154.645 161.31 155.035 161.79 155.035H169.28C169.761 155.035 170.15 154.645 170.15 154.165V147.405C170.15 146.924 169.761 146.535 169.28 146.535Z'
            fill='white'
          />
          <path
            opacity='0.4'
            d='M182 146.535H174.51C174.03 146.535 173.64 146.924 173.64 147.405V154.165C173.64 154.645 174.03 155.035 174.51 155.035H182C182.481 155.035 182.87 154.645 182.87 154.165V147.405C182.87 146.924 182.481 146.535 182 146.535Z'
            fill='white'
          />
          <g opacity='0.3'>
            <path
              d='M203.89 125.485H204.89V118.485H191.89V110.485H190.89V118.485H177.89V125.485H178.89V119.485H203.89V125.485Z'
              fill='white'
            />
            <path
              d='M177.89 141.485H164.89V146.485H165.89V142.485H177.89V146.485H178.89V135.485H177.89V141.485Z'
              fill='white'
            />
            <path
              d='M204.89 142.485V135.485H203.89V142.485H191.89V146.485H192.89V143.485H203.89V146.485H204.89V143.485H215.89V146.485H216.89V142.485H204.89Z'
              fill='white'
            />
          </g>
          <path
            opacity='0.2'
            d='M229.89 94.0747V116.485H174.96C173.641 116.441 172.387 115.902 171.448 114.976C170.508 114.049 169.952 112.803 169.89 111.485V89.4847H225.6C226.191 89.4803 226.775 89.5984 227.318 89.8315C227.86 90.0646 228.349 90.4076 228.752 90.8389C229.155 91.2703 229.464 91.7806 229.66 92.3375C229.856 92.8945 229.934 93.486 229.89 94.0747Z'
            fill='black'
          />
          <path
            d='M331.86 55.6746H263.78C261.179 55.6746 259.07 57.7833 259.07 60.3846V128.465C259.07 131.066 261.179 133.175 263.78 133.175H331.86C334.462 133.175 336.57 131.066 336.57 128.465V60.3846C336.57 57.7833 334.462 55.6746 331.86 55.6746Z'
            fill='rgb(33, 111, 237)'
          />
          <path opacity='0.25' d='M326.61 65.7947H269.03V123.045H326.61V65.7947Z' fill='white' />
          <path opacity='0.35' d='M280.71 100.985H274.91V115.855H280.71V100.985Z' fill='white' />
          <path opacity='0.35' d='M280.71 100.985H274.91V123.045H280.71V100.985Z' fill='white' />
          <path opacity='0.35' d='M290.71 90.5647H284.91V112.455H290.71V90.5647Z' fill='white' />
          <path opacity='0.35' d='M290.71 90.5647H284.91V123.045H290.71V90.5647Z' fill='white' />
          <path opacity='0.35' d='M300.72 96.9746H294.92V114.545H300.72V96.9746Z' fill='white' />
          <path opacity='0.35' d='M300.72 96.9746H294.92V123.045H300.72V96.9746Z' fill='white' />
          <path opacity='0.35' d='M310.73 87.9746H304.93V111.615H310.73V87.9746Z' fill='white' />
          <path opacity='0.35' d='M310.73 87.9746H304.93V123.045H310.73V87.9746Z' fill='white' />
          <path opacity='0.35' d='M320.73 74.2246H314.93V107.125H320.73V74.2246Z' fill='white' />
          <path opacity='0.35' d='M320.73 74.2246H314.93V123.045H320.73V74.2246Z' fill='white' />
          <path
            opacity='0.2'
            d='M279.89 55.4846V97.8846C279.859 99.1348 279.332 100.321 278.427 101.184C277.521 102.046 276.31 102.514 275.06 102.485H258.89V60.3746C258.918 59.0882 259.441 57.8621 260.35 56.9513C261.259 56.0405 262.484 55.5152 263.77 55.4846H279.89Z'
            fill='black'
          />
          <path
            d='M267.95 2.52466H199.87C197.269 2.52466 195.16 4.6334 195.16 7.23466V75.3147C195.16 77.9159 197.269 80.0247 199.87 80.0247H267.95C270.551 80.0247 272.66 77.9159 272.66 75.3147V7.23466C272.66 4.6334 270.551 2.52466 267.95 2.52466Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.25'
            d='M259.006 45.3495C261.255 31.4973 251.848 18.445 237.996 16.1965C224.144 13.9479 211.091 23.3546 208.843 37.2069C206.594 51.0591 216.001 64.1114 229.853 66.3599C243.705 68.6084 256.758 59.2018 259.006 45.3495Z'
            fill='white'
          />
          <path
            opacity='0.25'
            d='M233.89 41.2747L258.89 46.0147C257.989 50.7505 255.759 55.1322 252.461 58.6482C249.163 62.1643 244.933 64.6697 240.265 65.8719C235.596 67.0741 230.682 66.9235 226.096 65.4377C221.51 63.9518 217.442 61.1921 214.365 57.4807C211.289 53.7693 209.331 49.2593 208.722 44.4772C208.113 39.6952 208.876 34.8384 210.923 30.474C212.97 26.1096 216.217 22.4175 220.283 19.8289C224.35 17.2403 229.069 15.8619 233.89 15.8547V41.2747Z'
            fill='white'
          />
          <path
            opacity='0.25'
            d='M233.89 41.2747V66.6847C227.237 66.5439 220.904 63.7997 216.252 59.0414C211.6 54.283 208.999 47.8901 209.008 41.2354C209.017 34.5807 211.636 28.195 216.301 23.4495C220.967 18.704 227.307 15.9772 233.96 15.8547L233.89 41.2747Z'
            fill='white'
          />
          <path
            opacity='0.25'
            d='M233.891 41.2747L220.5 19.6747C222.487 18.4369 224.639 17.4842 226.891 16.8447C229.14 16.193 231.469 15.8564 233.811 15.8447L233.891 41.2747Z'
            fill='white'
          />
          <path
            d='M368.14 91.4846C368.14 91.4846 381.64 115.145 382.64 120.815C383.64 126.485 371.14 162.735 371.14 162.735C371.14 162.735 373.89 172.275 370.89 173.885C367.89 175.495 362.65 178.735 361.89 175.985C361.13 173.235 361.89 164.165 361.89 164.165L364.15 162.235C364.15 162.235 372.15 124.355 372.15 123.045C372.15 121.735 357.64 99.3946 357.64 99.3946L368.14 91.4846Z'
            fill='#E4897B'
          />
          <path
            d='M318.37 322.515L310.26 323.365L309.85 318.665L308.74 305.875L316.85 305.015L318.08 319.145L318.37 322.515Z'
            fill='#E4897B'
          />
          <path
            d='M358.85 321.485H350.99L350.92 319.705L350.91 319.485L350.51 308.085L350.5 307.855L350.34 303.485H358.21L358.85 321.485Z'
            fill='#E4897B'
          />
          <path
            opacity='0.2'
            d='M316.85 305.015L318.08 319.145L309.85 318.665L308.74 305.875L316.85 305.015Z'
            fill='black'
          />
          <path
            opacity='0.2'
            d='M358.801 320.485H358.79L350.921 319.485H350.91L350.5 308.485H350.51L358.391 309.115L358.79 320.135L358.801 320.485Z'
            fill='black'
          />
          <path
            d='M377.17 102.815L363.64 112.015L363.38 111.685L355.17 100.985L350.17 94.4246L357.6 74.2246C366.14 77.4846 377.17 102.815 377.17 102.815Z'
            fill='#263238'
          />
          <path
            opacity='0.2'
            d='M363.38 111.685L355.17 100.985L361.76 90.8745C361.76 90.8745 365.79 101.315 363.38 111.685Z'
            fill='black'
          />
          <path
            d='M349.89 321.015H359.44C359.597 321.014 359.75 321.067 359.872 321.165C359.994 321.264 360.078 321.401 360.11 321.555L361.66 328.555C361.693 328.724 361.687 328.899 361.644 329.067C361.602 329.234 361.523 329.39 361.413 329.524C361.303 329.657 361.166 329.765 361.01 329.839C360.854 329.914 360.683 329.953 360.51 329.955C357.42 329.905 355.17 329.715 351.29 329.715C348.9 329.715 341.69 329.965 338.39 329.965C335.09 329.965 334.66 326.705 336.01 326.405C342.07 325.085 346.63 323.255 348.57 321.515C348.929 321.184 349.402 321.005 349.89 321.015Z'
            fill='#263238'
          />
          <path
            d='M309.4 320.765H318.95C319.107 320.764 319.259 320.817 319.381 320.915C319.504 321.014 319.588 321.151 319.62 321.305L321.17 328.305C321.202 328.474 321.197 328.649 321.154 328.817C321.111 328.984 321.032 329.14 320.923 329.274C320.813 329.407 320.675 329.515 320.519 329.589C320.363 329.664 320.193 329.703 320.02 329.705C316.93 329.655 314.68 329.465 310.8 329.465C308.41 329.465 301.2 329.715 297.9 329.715C294.6 329.715 294.17 326.455 295.52 326.155C301.58 324.835 306.14 323.005 308.08 321.265C308.439 320.934 308.912 320.755 309.4 320.765Z'
            fill='#263238'
          />
          <path
            d='M308 317.485H319.53C319.53 317.485 318.59 218.235 331.06 184.715C331.94 195.795 332.93 207.285 333.9 216.865C334.5 222.795 335.11 227.865 335.68 231.775C339.31 256.775 348.46 318.485 348.46 318.485H359.89C359.89 318.485 358.53 259.345 357.19 234.785C355.7 208.115 355.06 149.485 354.99 144.485H313.25C309.28 165.485 299.1 249.485 308 317.485Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            opacity='0.6'
            d='M308 317.485H319.53C319.53 317.485 318.59 218.235 331.06 184.715C331.94 195.795 332.93 207.285 333.9 216.865C334.5 222.795 335.11 227.865 335.68 231.775C339.31 256.775 348.46 318.485 348.46 318.485H359.89C359.89 318.485 358.53 259.345 357.19 234.785C355.7 208.115 355.06 149.485 354.99 144.485H313.25C309.28 165.485 299.1 249.485 308 317.485Z'
            fill='white'
          />
          <path
            d='M328.39 56.3545C328.49 56.7345 328.6 57.1145 328.73 57.4645C329.671 60.0888 331.572 62.2584 334.05 63.5345C335.947 64.5478 338.123 64.9125 340.247 64.5731C342.37 64.2336 344.324 63.2086 345.81 61.6545C349.75 57.6545 349.65 53.0845 350.09 45.3145C350.226 43.4994 349.894 41.68 349.126 40.0295C348.359 38.379 347.182 36.9524 345.707 35.8857C344.233 34.819 342.509 34.1476 340.702 33.9356C338.894 33.7236 337.062 33.978 335.38 34.6745C327.75 37.7845 326.71 49.3545 328.39 56.3545Z'
            fill='#E4897B'
          />
          <path
            opacity='0.2'
            d='M332.62 62.6545C333.074 62.9838 333.552 63.278 334.05 63.5345C335.352 64.225 336.791 64.6164 338.263 64.6804C339.735 64.7445 341.203 64.4794 342.56 63.9045C342.215 62.9672 341.747 62.0796 341.17 61.2645C338.246 60.8985 335.278 61.381 332.62 62.6545Z'
            fill='black'
          />
          <path
            d='M348.27 72.7346C344.44 76.2146 335.06 74.9246 335.06 74.9246C335.06 74.9246 329.2 73.3246 330.43 71.4946C333.88 70.9246 335.55 69.3146 336.24 67.2546C336.618 65.9777 336.737 64.6382 336.59 63.3146C336.533 62.5766 336.436 61.8422 336.3 61.1146L347.89 52.4846C346.38 58.1946 344.52 68.6246 348.27 72.7346Z'
            fill='#E4897B'
          />
          <path
            d='M332.12 39.8746C332.2 40.0946 332 40.5446 331.85 41.0546C331.571 42.0541 331.43 43.0869 331.43 44.1246C331.462 45.8158 331.833 47.4834 332.52 49.0291C333.207 50.5749 334.196 51.9674 335.43 53.1246C336.297 56.2681 337.469 59.3193 338.93 62.2346C339.056 62.5359 339.255 62.8008 339.51 63.0046C339.855 63.1831 340.246 63.2496 340.63 63.1946L347.41 62.9646C347.609 62.9843 347.809 62.9606 347.997 62.895C348.185 62.8293 348.357 62.7234 348.5 62.5846C348.604 62.3902 348.688 62.1858 348.75 61.9746C349.36 60.5146 351.94 61.2046 352.83 59.8946C353.089 59.3011 353.268 58.6755 353.36 58.0346C353.92 56.4146 356.21 55.5746 356.13 53.8546C356.08 52.8546 355.13 51.9546 355.45 50.9946C355.77 50.0346 356.95 49.7346 357.45 48.8746C357.95 48.0146 357.45 46.8746 356.9 46.0746C356.576 45.6955 356.333 45.2544 356.185 44.7781C356.037 44.3019 355.988 43.8005 356.04 43.3046C356.179 42.9353 356.353 42.5803 356.56 42.2446C356.88 41.5693 356.987 40.8129 356.867 40.0754C356.747 39.338 356.407 38.6542 355.89 38.1146C355.418 37.7457 355 37.3114 354.65 36.8246C354.19 35.9546 354.58 34.8246 354.02 33.9546C353.46 33.0846 352.31 33.1146 351.33 33.1746C350.35 33.2346 349.19 33.1746 348.61 32.4346C348.19 31.8646 348.21 31.0546 347.75 30.5246C347.09 29.7846 345.89 29.9846 344.96 30.3546C344.03 30.7246 343.01 31.1946 342.11 30.7846C341.48 30.4946 341.11 29.8546 340.54 29.4746C340.137 29.2137 339.661 29.0877 339.181 29.1147C338.701 29.1416 338.242 29.3202 337.87 29.6246C337.37 30.0546 337.07 30.7046 336.5 31.0446C335.63 31.3893 334.661 31.3893 333.79 31.0446C333.357 30.8718 332.885 30.8206 332.425 30.8963C331.965 30.9721 331.535 31.172 331.18 31.4746C330.34 32.4746 331.25 34.2546 330.39 35.2646C329.9 35.8446 329 35.9246 328.47 36.4646C328.307 36.6601 328.196 36.893 328.145 37.1424C328.094 37.3917 328.106 37.6498 328.179 37.8934C328.252 38.1371 328.385 38.3588 328.565 38.5388C328.745 38.7187 328.967 38.8513 329.21 38.9246C329.51 38.9846 329.9 39.0046 330.01 39.2846C330.04 39.4095 330.06 39.5365 330.07 39.6646C330.18 40.0546 330.73 40.0746 331.07 39.9446C331.77 39.6746 332.05 39.6946 332.12 39.8746Z'
            fill='#263238'
          />
          <path
            d='M337.04 49.8346C336.893 50.5666 336.585 51.2563 336.136 51.8533C335.688 52.4503 335.112 52.9394 334.45 53.2846C332.87 53.9546 331.83 51.7246 332.06 49.3946C332.28 47.3146 333.35 44.3946 335.06 44.7846C336.77 45.1746 337.59 47.7446 337.04 49.8346Z'
            fill='#E4897B'
          />
          <path
            opacity='0.2'
            d='M331.061 184.665C331.941 195.745 332.931 207.265 333.901 216.845C335.321 203.015 337.061 193.155 337.061 193.155C337.061 193.155 338.691 191.815 343.171 184.665C347.651 177.515 343.171 164.165 343.171 164.165C343.311 176.565 331.061 184.665 331.061 184.665Z'
            fill='black'
          />
          <path
            d='M356.89 152.815L309.22 150.485C310.274 133.121 312.392 115.839 315.56 98.7345C316.863 91.8636 318.532 85.0672 320.56 78.3745C321.592 74.9792 322.804 71.6412 324.19 68.3745C324.19 68.3745 353.82 70.8145 359.89 75.4845C365.96 80.1545 356.56 128.485 356.89 152.815Z'
            fill='#263238'
          />
          <path
            d='M332.03 69.1644C332.03 69.1644 336.56 65.6045 345.03 65.7945C353.5 65.9845 354.36 69.1644 354.36 69.1644C354.36 69.1644 363.69 73.8145 356.36 81.4845C349.03 89.1545 334.59 69.7245 334.59 69.7245L332.03 69.1644Z'
            fill='#263238'
          />
          <path
            opacity='0.25'
            d='M332.03 69.1644C332.03 69.1644 336.56 65.6045 345.03 65.7945C353.5 65.9845 354.36 69.1644 354.36 69.1644C354.36 69.1644 363.69 73.8145 356.36 81.4845C349.03 89.1545 334.59 69.7245 334.59 69.7245L332.03 69.1644Z'
            fill='white'
          />
          <path
            opacity='0.2'
            d='M324.941 78.9845C324.941 78.9845 322.891 92.4845 315.561 98.7345C316.863 91.8636 318.532 85.0672 320.561 78.3745L324.941 78.9845Z'
            fill='black'
          />
          <path
            d='M318.83 68.5447C318.83 68.5447 289.22 62.4947 285.06 60.9047C280.9 59.3147 258.89 38.2747 258.89 38.2747L254.07 41.9147C254.07 41.9147 270.56 63.3147 278.81 69.4847C287.06 75.6547 315.89 84.9747 315.89 84.9747L318.83 68.5447Z'
            fill='#E4897B'
          />
          <path
            d='M325.011 68.5445L299.221 63.8345L298.561 81.6545L317.831 89.4845C317.831 89.4845 329.981 77.2945 325.011 68.5445Z'
            fill='#263238'
          />
          <path
            d='M258.89 38.2746C256.52 35.5646 247.89 29.7146 246.62 29.2146C245.35 28.7146 243.51 36.3646 243.88 37.3646C244.25 38.3646 248.49 40.4846 250.63 40.7346C252.77 40.9846 255.05 43.1746 255.05 43.1746L258.89 38.2746Z'
            fill='#E4897B'
          />
          <path
            d='M297.82 63.1846L300.65 63.8346L299.36 81.9746L296.65 80.9846L297.82 63.1846Z'
            fill='#263238'
          />
          <path
            opacity='0.25'
            d='M297.82 63.1846L300.65 63.8346L299.36 81.9746L296.65 80.9846L297.82 63.1846Z'
            fill='white'
          />
          <path
            d='M361.89 111.865L377.17 101.515L378.22 104.155L363.66 113.315L361.89 111.865Z'
            fill='#263238'
          />
          <path
            opacity='0.25'
            d='M361.89 111.865L377.17 101.515L378.22 104.155L363.66 113.315L361.89 111.865Z'
            fill='white'
          />
          <path
            d='M306.7 314.235L307.27 317.485H320.89V314.485L306.7 314.235Z'
            fill='rgb(33, 111, 237)'
          />
          <path
            d='M347.16 315.485L348.46 318.485H359.89L360.64 315.485H347.16Z'
            fill='rgb(33, 111, 237)'
          />
        </g>
        <defs>
          <clipPath id='clip0_109_144'>
            <rect width='384' height='330' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}
